module.exports = __webpack_public_path__ + "img/logo_sp@2x.2392e284.png";